import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Style.css';

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ModalWrapper from '../../../../../shared/modal/ModalWrapper';
import { EmptyGraph } from '../emptyGraph/EmptyGraph';

function TopThree(props) {
  const { t } = useTranslation();
  const [list, setList] = useState(
    props.data
      ? props.data
      : [
          { title: t('TS001'), value: 42 },
          { title: t('TS002'), value: 12 },
          { title: t('TS003'), value: 5 },
        ]
  );

  useEffect(() => {
    setList(props.data.map((item) => ({ ...item, newwidth: item.value })));
  }, [props.data]);

  if (props.disabled) {
    return <EmptyGraph title={props.title} />;
  }

  return (
    <div className={`${props.square ? 'square' : 'narrow'}  ${props.disabled ? 'disabled' : ''}`}>
      <div className={`square_content ${props.disabled ? 'disabled' : ''}`}>
        {props.modalText && !props.disabled && (
          <ModalWrapper modalText={props.modalText} onOpenModal={props.onOpenModal}>
            <FontAwesomeIcon icon={faInfo} className="icon info_icon" />
          </ModalWrapper>
        )}
        {props.disabled && <FontAwesomeIcon icon={faInfo} className="icon info_icon" />}
        {props.title ? <h3>{props.title}</h3> : ''}
        {props.disabled && <div className="graph_disabled_text">{t('BC014')}</div>}
        <div className={`top_three top_three_graph ${props.disabled ? 'disabled' : ''}`}>
          {props.subTitle ? <span>{props.subTitle}</span> : ''}
          {props.preText && <div className="sub_head">{props.preText}</div>}
          {list.map((item, index) => {
            const barWidth = item.newwidth || '0%';
            const title = item.title === 'COVID_19' ? 'COVID-19' : item.title;
            return (
              <div key={index} className="top_three_row">
                <h4>{title.replaceAll('_', ' ')}</h4>
                <div className="ttg_container">
                  <div className="ttg_fill" style={{ width: `${barWidth}%` }}>
                    <span>{`${item.value}%`}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default TopThree;
